// extracted by mini-css-extract-plugin
export default {"title":"dispatch-ticket-display_title__7tLvw","buttonContainer":"dispatch-ticket-display_buttonContainer__36DHH","tooltipClass":"dispatch-ticket-display_tooltipClass__3mJC7"};